import React from "react";

const SectionHeading = ({ eyebrow, title, text, center = false, as: Tag = "h2" }) => (
  <div className={`section-heading${center ? " section-heading--center" : ""}`}>
    {eyebrow && <span className="eyebrow">{eyebrow}</span>}
    <Tag>{title}</Tag>
    {text && <p>{text}</p>}
  </div>
);

export default SectionHeading;
